<template lang="pug">
.content-download-container
  el-header(height='40px') {{ downloads.length }} {{$t(' synchronizations ')}} {{ type === 'inProgress' ? $t('in progress'): $t(type)}}
    el-input(id="UpdateContentProgressReportList-searchInput", v-model='searchByName', style='width: 30%; margin-left: 10px;', clearable, size="mini", prefix-icon="el-icon-search")
    el-switch.finished-switch(v-model="showFinished", :active-text="$t('Recently finished')", :inactive-text="$t('In progress')")
    el-button.float-right(id="UpdateContentProgressReportList-stopAllButton", v-if="downloads.length > 1 && !hideStopAllButton", type="success", size="mini", @click="hideStopAllButton = true; stopAllContentUpdateRequests()")
      font-awesome-icon(icon="ban")
      span &nbsp; {{$t('Stop all')}}
    hr.header
  .content-download-row(v-for="contentDownload in downloads", :key="contentDownload.id")
    .cell.progress
      el-progress(:percentage='roundProgress(contentDownload.progress)', color='#0071ff')
    .cell.device(v-if='contentDownload.ContentDownloadDeviceDesktop')
      span {{ getFullDeviceNameByDesktopId(contentDownload.ContentDownloadDeviceDesktop) }}
    .cell.device(v-else)
      span &nbsp; {{ $t('Deleted Device?') }}
    .cell.time
      span {{ humanTime(parseInt(contentDownload.updatedAt)) }}
    .cell.delete-button.float-right(v-if='type === "inProgress"')
      el-button(
        :id="'UpdateContentProgressReportList-stopDownload'+contentDownload.id",
        type="success",
        size="mini",
        :disabled="stopButtonDisabled(contentDownload)"
        :title="$t('Stop content download')",
        @click="stopContentDownload(contentDownload)"
      )
        font-awesome-icon(icon="ban")
</template>

<script>
import ListItemMixin from '../Medium/ListItem.mixin'
import textUtils from '../Common/textUtils.mixin'

export default {
  mixins: [ListItemMixin, textUtils],
  props: ['side', 'type'],
  async created () {
    await this.$store.dispatch('Device/getContentDownloads')
  },
  data () {
    return {
      errors: {
      },
      contentDownloadsStopped: [],
      hideStopAllButton: false,
      searchByName: '',
      showFinished: false
    }
  },
  methods: {
    roundProgress (progress) {
      return parseInt(progress)
    },
    async stopContentDownload (contentDownload) {
      this.contentDownloadsStopped.push(contentDownload)
      this.$emit('stopContentDownload', contentDownload)
    },
    async stopAllContentUpdateRequests () {
      for (const contentDownload of JSON.parse(JSON.stringify(this.downloads))) {
        await this.stopContentDownload(contentDownload)
      }
      this.$emit('finished')
    },
    stopButtonDisabled (contentDownload) {
      return this.contentDownloadsStopped.findIndex(cd => cd.id === contentDownload.id) > -1
    }
  },
  computed: {
    downloads () {
      let filteredDownloads = this.$store.state.Device.content_downloads
      if (this.showFinished) {
        filteredDownloads = filteredDownloads.filter(d => d.progress === 100)
      } else {
        filteredDownloads = filteredDownloads.filter(d => d.progress < 100)
      }
      if (this.searchByName.length > 0) {
        filteredDownloads = filteredDownloads.filter((cd) => {
          return this.getFullDeviceNameByDesktopId(cd.ContentDownloadDeviceDesktop).toLowerCase().indexOf(this.searchByName.toLowerCase()) > -1
        })
      }
      return filteredDownloads
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
  .content-download-row {
    display: flex;
    font-size: $--font-size-base;
    align-items: center;
    border-bottom: $--border-light;
    padding: 10px 0px;
    .cell {
      &:first-child {
        padding-left: 0px;
      }
      padding: 0px 20px;
      overflow: hidden;
      user-select: none;
    }
    .progress {
      width:50%;
    }
    .device {
      width:20%;
    }
    .time {
      width:20%;
    }
    .delete-button {
      width:10%;
      text-align: right;
      padding-right: 0px;
    }
  }
  .finished-switch {
    margin-left: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Device/UpdateContentProgressReportList.vue